import { Avatar, CircularProgress, Tooltip } from "@mui/material";
import { usePaisLogo } from "src/hooks/usePaisLogo";
import { EntityWithIdAndDescriptionFields, PaisLogoFields } from "../../types";

interface CountryAvatarProps extends React.ComponentProps<typeof Avatar> {
    countryCode: number,
    tooltip?: string
}

export const CountryAvatar: React.FC<CountryAvatarProps> = ({ countryCode, tooltip, ...props }) => {
    const { getPaisLogoPorCodigo, loading } = usePaisLogo()
    const sistemaPrincipal = getPaisLogoPorCodigo(countryCode)

    if (loading) {
        return <CircularProgress />;
    }

    return (
        <Tooltip title={tooltip || sistemaPrincipal?.[EntityWithIdAndDescriptionFields.Description]}>
            <Avatar src={sistemaPrincipal?.[PaisLogoFields.Src]} {...props} />
        </Tooltip>
    )

};